module.exports = __webpack_public_path__ + "img/shooting-star.e81fed6c.png";